import React from "react";
import { Box, CircularProgress } from "@mui/joy";
import type { SxProps } from "@mui/joy/styles/types";
import {
  cardValidationListRootSx,
  scrollableListPageLayoutHeaderStripSx,
  scrollableListPageLayoutLoadingOverlaySx,
  scrollableListPageLayoutPaginationStripSx,
  scrollableListPageLayoutScrollBoxSx,
} from "../../styles/globalStyles";

export type ScrollableListPageLayoutProps = {
  children: React.ReactNode;
  isLoading?: boolean;
  pagination?: React.ReactNode;
  /** Optional strip above the scroll area (e.g. search on CustomersPage). */
  header?: React.ReactNode;
  sx?: SxProps;
};

/**
 * Generic shell: padded column, scrollable main region, optional loading overlay,
 * optional footer strip (e.g. pagination). Used for training lists, card validation, customers, etc.
 */
export default function ScrollableListPageLayout({
  children,
  isLoading = false,
  pagination,
  header,
  sx,
}: ScrollableListPageLayoutProps) {
  return (
    <Box sx={[cardValidationListRootSx, sx].filter(Boolean) as SxProps}>
      {header != null ? <Box sx={scrollableListPageLayoutHeaderStripSx}>{header}</Box> : null}
      <Box sx={scrollableListPageLayoutScrollBoxSx}>
        {children}
        {isLoading && (
          <Box sx={scrollableListPageLayoutLoadingOverlaySx}>
            <CircularProgress />
          </Box>
        )}
      </Box>

      {pagination ? <Box sx={scrollableListPageLayoutPaginationStripSx}>{pagination}</Box> : null}
    </Box>
  );
}
